import React from "react";
import { Confirmation } from "containers/components/confirmation";

const ApplyChangesConfirmation = (props) => (
    <Confirmation
        open={props.open}
        onConfirm={props.onConfirm}
        onClose={props.onClose}
    >
        Are you sure you want to apply those changes?
    </Confirmation>
)

export default ApplyChangesConfirmation;
